import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentSetupService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useIsResidualsStatusConfirmationRequiredMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ userId }: { userId: string }) => {
			dispatch(uiActions.showSpinnerOverlay());
			return agentSetupService.checkIsResidualsStatusConfirmationRequired(
				{
					userId,
				},
			);
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useIsResidualsStatusConfirmationRequiredMutation;
